import React, { useEffect, useState } from "react";
import { Typography } from "@mui/material";

const Footer = () => {
  const [version, setVersion] = useState("");

  useEffect(() => {
    fetch("/version")
      .then((response) => response.json())
      .then((data) => {
        if (data.version) {
          setVersion(data.version);
        }
      });
  }, []);

  return (
    <footer
      style={{
        position: "fixed",
        left: 0,
        bottom: 0,
        width: "100%",
        height: "35px",
        backgroundColor: "#f5f5f5",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Typography variant="body2" color="textSecondary">
        Vivago License Server {version && " - Version " + version}
      </Typography>
    </footer>
  );
};

export default Footer;
